@if (memberService.account$ | async; as account) {
  <div class="display-flex align-items-center">
    @if (account.benefactor) {
      @if (!account.has_too_many_tokens_to_recharge && (headerService.hidingCreditsButton$ | async) === false) {
        <a
          class="mr-6"
          data-cy="buyCreditsBtn"
          sbButton
          sbNavigateToCredits="header-button"
          [size]="'small'"
          [variant]="'fill-gold'"
        >
          <span>Buy Credits</span>
        </a>
      }
      <a class="color-white mr-6" data-cy="tokenBalance" sbNavigateToCredits="header-button">
        <i class="nc-icon nc-credits color-gold"></i>
        {{ account.token_balance }}
      </a>
    }

    @if (account.dependent && memberService.needsVerification()) {
      <a class="mr-6" sbButton [routerLink]="['/next/me/verifications']" [size]="'small'" [variant]="'fill-verified'">
        Get Verified
      </a>
    }

    <div class="nav-toggle" data-cy="siteNavToggle" (click)="siteNavService.toggle()">
      @if (siteNavService.visible$ | async) {
        <button sbButton [@siteNavToggle] [iconOnly]="true" [variant]="'fill-semi-transparent-white'">
          <i class="nc-icon nc-simple-remove i-8 color-white"></i>
        </button>
      } @else {
        <div class="img" [@siteNavToggle] [ngStyle]="profilePhotoStyle$ | async"></div>
      }
    </div>
  </div>
}
